import Axios from "axios"

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export function GetChangePasswordCodeService(token) {
    return new Promise(async(resolve, reject) => {
        try { 
            const response = await Axios.get( `${URL_AUTH}/api/admin/v1/user/password/send/code`, {
                headers: {
                    "X-localization":`${window.localStorage.getItem("i18nextLng")}`,
                    Authorization: `Bearer ${token}`,
                }
            })
            resolve(response)
        } catch (error) {
            reject(error)
        }
    })    
}
